import IconStar from "./assets/images/star.svg?react";
import "./styles/Rating.scss";

type Props = {
  value: number;
  ratingCount: number;
  className?: string;
}

const CLASS_PREFIX = `ws-widgets-rating`;

export const Rating = ({ value, ratingCount }: Props) => {
  const max = 5;
  const percentage = Math.round((value / max) * 100);
  const stars = Array.from(Array(max).keys());

  return (
    <div className={ `${ CLASS_PREFIX }` }>
      <div className={ `${ CLASS_PREFIX }__stars` }>
        {
          stars.map((_, i) => (
            <div key={ i } className={ `${ CLASS_PREFIX }__star` }>
              <IconStar key={ i }/>
            </div>
          ))
        }
        <div className={ `${ CLASS_PREFIX }__overlay` } style={{ width: `${100 - percentage}%` }}>
          &nbsp;
        </div>

      </div>
      { value > 0 && ratingCount > 0 &&
        <div className={ `${ CLASS_PREFIX }__text` }>
          { ratingCount } review{ ratingCount > 1 ? `s` : ``  }
        </div>
      }
    </div>
  );
}
